import React from 'react';
// import './Card.css';
import '../../styles/scss/card.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheckDouble } from '@fortawesome/free-solid-svg-icons';

/**
 * 
 * titleIcon: Icon to be placed in Card title
 * title : Title of card
 * titleDescription: Description of title.
 * children: content of card
 * footer: footer of card. If not provided, it wont render.
 * titleBorder: true/false.
 * cardRef: ref for main div of card.
 * hideHeader: if sent true, header will hide
 * border: if sent false, border will not be shown
 * shadow: if sent true, shadow will be shown
 */
function Card({ id='', hideHeader=false, border=true, shadow=false, titleIcon= faCheckDouble, title = 'Primary Information',titleDescription='All the fields marked with an asterisk (*) are mandatory.', headerActions = null, children, footer, titleBorder = false, footerAlign = "right",cardRef=null, maxHeight = 'auto',bodyOverflow='unset' }) {
    
    return (
        <>
            <div id={id} className={`as-card ${border ? ` as-card-bordered` : ``} ${shadow ? ` as-card-shadowed` : ``} ${hideHeader ? 'as-card-no-padding' : ''}`} ref={cardRef}>

                {hideHeader?<></>:
                    <div className="as-card-head">
                        <div className="as-card-head-icon">
                            {(titleIcon!=null?<FontAwesomeIcon icon={titleIcon} />:<></>)}
                        </div>
                        <div className="as-card-head-title">
                            <span className='as-card-head-title-text'>
                                {title}
                            </span>
                            {titleDescription != '' ?
                                <span className='as-card-head-title-description'>
                                    {titleDescription}
                                </span>
                                :
                                <></>
                            }
                        </div>
                        {
                            (headerActions != null)
                            &&
                                <div className='as-card-head-action-btn-wrapper'>
                                    {headerActions}
                                </div>
                        }
                    </div>
                }
                    
            
                <div className="as-card-body" style={{maxHeight:maxHeight,overflow:bodyOverflow}}>
                    {children}
                </div>

                {(footer === undefined ? <></> :
                    
                    <div className="as-card-foot" style={{ textAlign: footerAlign, border: '0px'}}>
                        {footer}
                    </div>
                )}

            </div>
        </>
    );
}

export default Card;